import { useGlobalStore } from '@highlight/ipc/react'

export const useAutoInsertPermission = () => {
  const [isAutoInsertEnabled, setIsAutoInsertEnabled] = useGlobalStore<boolean>('settings', 'ptt.autoInsert', false)

  return {
    isAutoInsertEnabled,
    setIsAutoInsertEnabled,
  }
}
